<script>
  import ApexCharts from "apexcharts";
  import { onMount } from "svelte";
  import { construct_svelte_component } from "svelte/internal";

  export let percentage;
  export let color = "#000000";
  let uniqueID = Math.random().toString(36).slice(2, 12);
  let chart = null;

  onMount(() => {
    const options = {
      series: [0],
      chart: {
        height: 100,
        width: 75,
        // width: '10%',
        type: "radialBar",
        sparkline: {
          enabled: true,
        },
      },
      colors: [color],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "25%",
          },
          dataLabels: {
            show: false,
          },
        },
      },
      labels: [""],
    };
    chart = new ApexCharts(document.getElementById(uniqueID), { ...options });
    chart.render();
  });
  $: {
    if (percentage !== undefined && !Number.isNaN(percentage) && chart) {
      chart.updateOptions({
        series: [percentage]
      })
    }
  }
</script>
<style>
  .gauge-container {
    margin: 0px -5px;
  }
  @media screen and (min-width: 1024px) {
    .gauge-container {
      margin: 0px -15px;
    }
  }
</style>
<div class="gauge-container" id={uniqueID} />
